import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import UrlTo from '../../../url-to';
import { t } from '../../../i18n';
import NavigationSidebar from './navigation-sidebar';
import GuestDesktopNavbar from './GuestDesktopNavbar';
import ProfileDesktopNavbar from './ProfileDesktopNavbar';
import GuestMobileNavbar from './GuestMobileNavbar';
import ProfileMobileNavbar from './ProfileMobileNavbar';
import HeaderLogo from '../logo/HeaderLogo';
import HideIntercom from '../../../components/hide-intercom';
import useCurrentUser from '../../current-user/useCurrentUser';
import { logout } from '../../../login/actions';
import './styles.scss';

const Header = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const { isAuthenticated, currentUser } = useCurrentUser();
  const dispatch = useDispatch();

  const closeSidebar = () => setShowSidebar(false);
  const toggleShowSidebar = () => setShowSidebar(!showSidebar);

  const handleLogout = () => {
    const returnUrl = UrlTo.coursesHome();
    dispatch(logout(returnUrl));
    closeSidebar();
  };

  return (
    <div className="courses-header">
      <div className="courses-header__sidebar">
        <div className="courses-header__toggle-button" onClick={toggleShowSidebar}>
          <i className="courses-header__toggle-button-icon fas fa-bars" />
        </div>
        <NavigationSidebar show={showSidebar} onHide={closeSidebar}>
          <HideIntercom />
          <div className="courses-header__sidebar-body">
            <ul>
              <li>
                <Link to={UrlTo.coursesHome()} onClick={closeSidebar}>
                  {t('DIGITAL_COURSES.HEADER.OUR_COURSES')}
                </Link>
              </li>
              <li>
                <Link to={UrlTo.coursesGiftCardOverview()} onClick={closeSidebar}>
                  {t('DIGITAL_COURSES.HEADER.GIFT_CARD')}
                </Link>
              </li>
              <li>
                <a href={UrlTo.offSiteContact()}>{t('DIGITAL_COURSES.HEADER.CONTACT_US')}</a>
              </li>
              {isAuthenticated && (
                <li>
                  <Link to={UrlTo.coursesProfile()} onClick={closeSidebar}>
                    {t('DIGITAL_COURSES.HEADER.MY_ACCOUNT')}
                  </Link>
                </li>
              )}
            </ul>
          </div>
          <footer className="courses-header__sidebar-footer">
            {!isAuthenticated && <GuestMobileNavbar />}
            {isAuthenticated && currentUser && <ProfileMobileNavbar user={currentUser} onLogout={handleLogout} />}
          </footer>
        </NavigationSidebar>
      </div>
      <div className="courses-header__centering-block">
        <HeaderLogo />
        <ul className="courses-header__navigation-bar">
          <li>
            <Link to={UrlTo.coursesHome()}>{t('DIGITAL_COURSES.HEADER.OUR_COURSES')}</Link>
          </li>
          <li>
            <Link to={UrlTo.coursesGiftCardOverview()}>{t('DIGITAL_COURSES.HEADER.GIFT_CARD')}</Link>
          </li>
          <li>
            <a href={UrlTo.offSiteContact()}>{t('DIGITAL_COURSES.HEADER.CONTACT_US')}</a>
          </li>
          {!isAuthenticated && <GuestDesktopNavbar />}
          {isAuthenticated && currentUser && <ProfileDesktopNavbar user={currentUser} onLogout={handleLogout} />}
        </ul>
      </div>
    </div>
  );
};

export default Header;
